import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { Radius, Typography } from '../../theme';

const DateSeparatorPill: React.FC<{ label: string }> = ({ label }) => (
  <View style={styles.row}>
    <View style={styles.line} />
    <View style={styles.pill}>
      <LinearGradient
        pointerEvents="none"
        colors={['rgba(255,255,255,0.12)', 'rgba(255,255,255,0.02)']}
        start={{ x: 0.1, y: 0 }}
        end={{ x: 0.9, y: 1 }}
        style={StyleSheet.absoluteFill}
      />
      <Text style={styles.text}>{label}</Text>
    </View>
    <View style={styles.line} />
  </View>
);

export default DateSeparatorPill;

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    marginVertical: 14,
    paddingHorizontal: 6,
  },
  line: {
    flex: 1,
    height: StyleSheet.hairlineWidth,
    backgroundColor: 'rgba(255,255,255,0.14)',
  },
  pill: {
    overflow: 'hidden',
    paddingHorizontal: 12,
    paddingVertical: 5,
    borderRadius: Radius.pill,
    borderWidth: 1,
    borderColor: 'rgba(255,255,255,0.16)',
    backgroundColor: 'rgba(10,14,22,0.55)',
  },
  text: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: Typography.xs,
    fontWeight: Typography.bold,
  },
});
